/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import baustein from "baustein";
import store from "web/redux/store";
import { watchState } from "web/redux/state-watcher";

const OPEN_STYLE = "feed-sidebar--open";

function openFeedSidebarSelector(state) {
    return state.feedSidebarReducer.open;
}

export default baustein.register("feed-sidebar", {
    init() {
        this.unsubscribeToStateWatcher = watchState(openFeedSidebarSelector, sidebarOpen => {
            sidebarOpen ? this.show() : this.close();
        });
    },

    onRemove() {
        this.unsubscribeToStateWatcher();
    },

    /**
     * Displays the feed sidebar to the user. This only affects the mobile and tablet views.
     * @returns {Promise} a resolved promise.
     */
    show() {
        this.el.classList.add(OPEN_STYLE);
        this.emit("overlayOpen");
        return Promise.resolve();
    },

    /**
     * Closes the feed sidebar. This only affects the mobile and tablet views.
     * @returns {Promise} a resolved promise.
     */
    close() {
        this.el.classList.remove(OPEN_STYLE);
        this.emit("overlayClose");
        return Promise.resolve();
    },

    /**
     * Read sidebar open state from redux.
     * @returns {boolean}
     */
    isOpen() {
        return openFeedSidebarSelector(store.getState());
    }
});

